import React from "react"

function ErrorMessage(props) {

    return (
        props.message ? <small className="error-message">{props.message}</small> : null
    )
    
}
export default ErrorMessage